import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const get = axios.get
const post = axios.post
const api = '/api/role/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const getRoles = createAsyncThunk('roles', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}list`, params), thunkAPI)
)

export const getPermissions = createAsyncThunk('permissions', (_, thunkAPI) =>
  handleRequest(get(`${api}get-permissions/`), thunkAPI)
)

export const createRole = createAsyncThunk('add-role', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const editRole = createAsyncThunk('role-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const getRole = createAsyncThunk('get-roles', (_, thunkAPI) =>
  handleRequest(get(`api/role/get-roles/`), thunkAPI)
)

export const deleteRole = createAsyncThunk('role-delete', (id: string, thunkAPI) =>
  handleRequest(post(`${api}destroy/${id}`), thunkAPI)
)

// Role Types
type RoleState = {
  roles: any
  role: any
  permission_list: any
  singleRole: any
  errors: any
}

const initialState: RoleState = {
  roles: {
    data: [],
  },
  role: [],
  permission_list: [],
  singleRole: {},
  errors: '',
}

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getRoles.fulfilled, (state, action: PayloadAction<any>) => {
      state.roles = action.payload
    })
  },
})

export const {reset} = roleSlice.actions
export default roleSlice.reducer
